(function () {
'use strict';

function initRoomBuilder() {

const builder = document.querySelector('.bb-builder');

if (!builder || builder.dataset.initialized === 'true') {
return;
}

builder.dataset.initialized = 'true';

let bundle = [];
let currentStep = 1;
let lastProductStep = 1;

const discountCodes = {
2: 'BEDBUILDER10',
3: 'BEDBUILDER15',
4: 'BEDBUILDER20'
};

const stepTitles = {
1: 'Select Your Sheet Set Option',
2: 'Select Your Flat Sheet Option',
3: 'Select Your Quilt Option',
4: 'Select Your Quilt Cover Set Option',
5: 'Select Your Extra Items'
};

const panels = Array.from(
builder.querySelectorAll('[data-panel]')
);

const stepButtons = Array.from(
builder.querySelectorAll('[data-step-btn]')
);

const titleElement =
builder.querySelector('#bb-title');

const countElement =
builder.querySelector('#bb-count');

const messageElement =
builder.querySelector('#bb-message');

const pillElement =
builder.querySelector('#bb-pill');

const drawer =
builder.querySelector('#bb-drawer');

const itemsElement =
builder.querySelector('#bb-items');


/*
* MOVE DRAWER TO BODY
*
* Prevents Shopify header/theme stacking
* from cutting off the drawer.
*/

if (
drawer &&
drawer.parentElement !== document.body
) {
document.body.appendChild(drawer);
}


function totalQuantity() {

return bundle.reduce(
function (total, item) {
return total + Number(item.quantity || 0);
},
0
);

}


function getDiscountTier() {

const total = totalQuantity();

if (total >= 4) return 4;
if (total >= 3) return 3;
if (total >= 2) return 2;

return 0;

}


function updateDiscountUI() {

const total = totalQuantity();
const tier = getDiscountTier();

document
.querySelectorAll(
'.bb-discount[data-tier], .bb-drawer-discounts [data-tier]'
)
.forEach(function (element) {

element.classList.toggle(
'is-active',
Number(element.dataset.tier) === tier
);

});


if (countElement) {
countElement.textContent = total;
}


if (pillElement) {

if (total >= 4) {

pillElement.textContent = '20% OFF';

} else if (total >= 3) {

pillElement.textContent = '15% OFF';

} else if (total >= 2) {

pillElement.textContent = '10% OFF';

} else {

pillElement.textContent = '';

}

}


if (messageElement) {

if (total < 2) {

const remaining = 2 - total;

messageElement.textContent =
'Add ' +
remaining +
' product' +
(remaining === 1 ? '' : 's') +
' to save 10%!';

} else if (total === 2) {

messageElement.textContent =
'You’re saving 10% on your room bundle!';

} else if (total === 3) {

messageElement.textContent =
'You’re saving 15% on your room bundle!';

} else {

messageElement.textContent =
'You’re saving 20% on your room bundle!';

}

}

}


function updatePreview() {

builder.classList.toggle(
'has-sheet',
bundle.some(function (item) {
return item.step === 1;
})
);

builder.classList.toggle(
'has-flat',
bundle.some(function (item) {
return item.step === 2;
})
);

builder.classList.toggle(
'has-quilt',
bundle.some(function (item) {
return item.step === 3;
})
);

builder.classList.toggle(
'has-cover',
bundle.some(function (item) {
return item.step === 4;
})
);

builder.classList.toggle(
'has-extra',
bundle.some(function (item) {
return item.step === 5;
})
);

}


function showStep(step, shouldScroll) {

step = Number(step);

if (step < 1) {
step = 1;
}

if (step > 5) {
step = 5;
}

currentStep = step;
lastProductStep = step;

builder.dataset.currentStep =
String(step);


panels.forEach(function (panel) {

const panelStep =
Number(panel.dataset.panel);

panel.classList.toggle(
'is-active',
panelStep === step
);

});


stepButtons.forEach(function (button) {

const buttonStep =
Number(button.dataset.stepBtn);

button.classList.toggle(
'is-active',
buttonStep === step
);

button.classList.toggle(
'is-complete',
buttonStep < step
);

});


if (titleElement) {

titleElement.textContent =
stepTitles[step] || '';

}


if (shouldScroll !== false) {

const top =
builder.querySelector('.bb-top');

if (top) {

window.scrollTo({
top:
Math.max(
0,
top.getBoundingClientRect().top +
window.scrollY -
20
),
behavior: 'smooth'
});

}

}

}


function isPreorderOption(option) {

if (!option) {
return false;
}

const preorderEnabled =
option.dataset.preorderEnabled === 'true';

const preorderQuantity =
Number(
option.dataset.preorderQuantity || 0
);

const available =
option.dataset.available === 'true';


if (preorderEnabled) {
return true;
}


if (
!available &&
preorderQuantity > 0
) {
return true;
}


return false;

}


/*
* PRICE + PRE-ORDER INFORMATION
*/

function updateCardPrice(card) {

const select =
card.querySelector('.bb-variant');

if (!select) {
return;
}

const option =
select.options[
select.selectedIndex
];

if (!option) {
return;
}


const price =
card.querySelector('.bb-price');

const compare =
card.querySelector('.bb-compare');


if (price) {

price.textContent =
option.dataset.priceDisplay || '';

}


if (compare) {

const priceValue =
Number(
option.dataset.price || 0
);

const compareValue =
Number(
option.dataset.compare || 0
);


if (
compareValue > priceValue
) {

compare.textContent =
option.dataset.compareDisplay || '';

compare.classList.remove(
'is-hidden'
);

} else {

compare.textContent = '';

compare.classList.add(
'is-hidden'
);

}

}


/*
* PRE-ORDER BOX
*/

let preorderBox =
card.querySelector(
'.bb-preorder-info'
);


if (!preorderBox) {

preorderBox =
document.createElement('div');

preorderBox.className =
'bb-preorder-info';

const qty =
card.querySelector(
'.bb-qty-wrap'
);

const addButton =
card.querySelector(
'.bb-add'
);


if (qty && addButton) {

qty.insertAdjacentElement(
'afterend',
preorderBox
);

}

}


const isPreorder =
isPreorderOption(option);


if (isPreorder) {

let message =
option.dataset.preorderMessage || '';


if (!message.trim()) {

message =
'OCTOBER/NOV PLEASE NOTE: If your order contains an in-stock item and pre-order item, your items will not be shipped until all items are in stock. If you would like to organise a split ship, please email us helloplaylinen@gmail.com or please place two separate orders.';

}


preorderBox.innerHTML =

'<span class="bb-preorder-badge">' +
'PRE-ORDER' +
'</span>' +

'<p class="bb-preorder-message">' +
escapeHtml(message) +
'</p>';


preorderBox.classList.add(
'is-visible'
);


} else {

preorderBox.innerHTML = '';

preorderBox.classList.remove(
'is-visible'
);

}

}


function showPopup() {

const popup =
builder.querySelector(
'#bb-cute-pop'
);

if (!popup) {
return;
}


popup.classList.add(
'is-visible'
);


clearTimeout(
popup._hideTimer
);


popup._hideTimer =
setTimeout(
function () {

popup.classList.remove(
'is-visible'
);

},
1500
);

}


/*
* ADD PRODUCT
*
* Automatically moves to next step.
*/

function addCardToBundle(card) {

const select =
card.querySelector('.bb-variant');

const quantityInput =
card.querySelector('.bb-qty-input');


if (
!select ||
!select.value
) {

alert(
'Please select an available variant.'
);

return;

}


const option =
select.options[
select.selectedIndex
];


if (!option) {
return;
}


const available =
option.dataset.available === 'true';

const preorder =
isPreorderOption(option);


if (
!available &&
!preorder
) {

alert(
'Sorry, this variant is currently sold out.'
);

return;

}


let quantity =
Number(
quantityInput
? quantityInput.value
: 1
);


quantity =
Math.max(
1,
Math.min(
10,
quantity
)
);


const variantId =
String(option.value);

const step =
Number(card.dataset.step);


const existing =
bundle.find(
function (item) {

return (
String(item.variantId) ===
variantId
);

}
);


if (existing) {

existing.quantity =
Math.min(
10,
existing.quantity +
quantity
);

} else {

bundle.push({

variantId:
variantId,

productId:
card.dataset.productId || '',

title:
card.dataset.title || '',

variantTitle:
option.dataset.variantTitle || '',

price:
Number(
option.dataset.price || 0
),

quantity:
quantity,

step:
step,

image:
card.querySelector('img')
? card.querySelector('img').src
: '',

preorder:
preorder

});

}


card.classList.add(
'selected'
);


renderBundle();
updateDiscountUI();
updatePreview();
showPopup();


/*
* MOVE TO NEXT STEP
*/

setTimeout(
function () {

if (step < 5) {

showStep(
step + 1,
true
);

} else {

openDrawer();

}

},
250
);

}


function renderBundle() {

if (!itemsElement) {
return;
}


if (!bundle.length) {

itemsElement.innerHTML =
'<div class="bb-no-items">No products selected yet.</div>';

return;

}


itemsElement.innerHTML =
bundle.map(
function (item, index) {

const image =
item.image
? '<img src="' +
item.image +
'" alt="" loading="lazy">'
: '';


const variant =
item.variantTitle &&
item.variantTitle !== 'Default Title'
? '<span>' +
escapeHtml(
item.variantTitle
) +
'</span>'
: '';


const preorder =
item.preorder
? '<small class="bb-preorder-label">Pre-order</small>'
: '';


return (

'<div class="bb-bundle-item">' +

'<div class="bb-bundle-image">' +
image +
'</div>' +

'<div class="bb-bundle-info">' +

'<strong>' +
escapeHtml(
item.title
) +
'</strong>' +

variant +

'<span>Qty ' +
item.quantity +
'</span>' +

preorder +

'</div>' +

'<div class="bb-bundle-price">' +
formatMoney(
item.price *
item.quantity
) +
'</div>' +

'<button ' +
'type="button" ' +
'class="bb-remove-item" ' +
'data-remove-index="' +
index +
'">' +
'×' +
'</button>' +

'</div>'

);

}
).join('');

}


function escapeHtml(value) {

return String(
value || ''
)
.replace(
/&/g,
'&amp;'
)
.replace(
/</g,
'&lt;'
)
.replace(
/>/g,
'&gt;'
)
.replace(
/"/g,
'&quot;'
)
.replace(
/'/g,
'&#039;'
);

}


function formatMoney(cents) {

return new Intl.NumberFormat(
document.documentElement.lang ||
'en-AU',
{
style: 'currency',
currency: 'AUD'
}
).format(
Number(cents || 0) / 100
);

}


function openDrawer() {

if (!drawer) {
return;
}


renderBundle();
updateDiscountUI();


drawer.classList.add(
'is-open'
);


drawer.setAttribute(
'aria-hidden',
'false'
);


document.body.classList.add(
'bb-drawer-open'
);


document.body.style.overflow =
'hidden';

}


function closeDrawer() {

if (!drawer) {
return;
}


drawer.classList.remove(
'is-open'
);


drawer.setAttribute(
'aria-hidden',
'true'
);


document.body.classList.remove(
'bb-drawer-open'
);


document.body.style.overflow =
'';

}


function backToProducts() {

closeDrawer();


showStep(
lastProductStep ||
currentStep ||
1,
true
);

}


function clearBundle() {

bundle = [];


builder
.querySelectorAll(
'.bb-card.selected'
)
.forEach(
function (card) {

card.classList.remove(
'selected'
);

}
);


builder
.querySelectorAll(
'.bb-qty-input'
)
.forEach(
function (input) {

input.value = '1';

}
);


renderBundle();
updateDiscountUI();
updatePreview();

}


async function addBundleToCart() {

if (!bundle.length) {

alert(
'Please add some products to your room first.'
);

return;

}


const total =
totalQuantity();


if (total < 2) {

alert(
'Please add at least 2 products to unlock the bundle discount.'
);

return;

}


const tier =
getDiscountTier();

const discountCode =
discountCodes[tier];


const button =
drawer
? drawer.querySelector(
'[data-drawer-cart]'
)
: null;


if (button) {

button.disabled = true;

button.textContent =
'Adding to Cart…';

}


try {

for (
const item of bundle
) {

const response =
await fetch(
'/cart/add.js',
{
method: 'POST',

headers: {
'Content-Type':
'application/json',

'Accept':
'application/json'
},

body:
JSON.stringify({
items: [
{
id:
Number(
item.variantId
),

quantity:
Number(
item.quantity
)
}
]
})
}
);


if (!response.ok) {

throw new Error(
'Unable to add item to cart.'
);

}

}


window.location.href =
'/discount/' +
encodeURIComponent(
discountCode
) +
'?redirect=/cart';


} catch (error) {

console.error(
'Room Builder cart error:',
error
);


alert(
'Something went wrong adding your room bundle to cart. Please try again.'
);


if (button) {

button.disabled = false;

button.textContent =
'Add Room Bundle To Cart';

}

}

}


/*
* STEP BUTTONS
*/

stepButtons.forEach(
function (button) {

button.addEventListener(
'click',
function () {

const step =
Number(
button.dataset.stepBtn
);

if (!step) {
return;
}

showStep(
step,
true
);

}
);

}
);


/*
* BUILDER EVENTS
*/

builder.addEventListener(
'click',
function (event) {


/*
* SKIP
*/

const topSkip =
event.target.closest(
'[data-top-skip]'
);


if (topSkip) {

event.preventDefault();


if (currentStep < 5) {

showStep(
currentStep + 1,
true
);

} else {

openDrawer();

}


return;

}


/*
* NEXT
*/

const next =
event.target.closest(
'[data-next-step]'
);


if (next) {

event.preventDefault();


const panel =
next.closest(
'[data-panel]'
);


if (!panel) {
return;
}


const panelStep =
Number(
panel.dataset.panel
);


if (panelStep < 5) {

showStep(
panelStep + 1,
true
);

} else {

openDrawer();

}


return;

}


/*
* BACK
*/

const back =
event.target.closest(
'[data-back]'
);


if (back) {

event.preventDefault();


const panel =
back.closest(
'[data-panel]'
);


if (!panel) {
return;
}


const panelStep =
Number(
panel.dataset.panel
);


if (panelStep > 1) {

showStep(
panelStep - 1,
true
);

}


return;

}


/*
* ADD TO ROOM
*/

const add =
event.target.closest(
'[data-action]'
);


if (add) {

event.preventDefault();


const card =
add.closest(
'[data-card]'
);


if (card) {

addCardToBundle(
card
);

}


return;

}


/*
* MINUS
*/

const minus =
event.target.closest(
'[data-qty-minus]'
);


if (minus) {

const card =
minus.closest(
'[data-card]'
);


const input =
card
? card.querySelector(
'.bb-qty-input'
)
: null;


if (input) {

input.value =
Math.max(
1,
Number(
input.value || 1
) - 1
);

}


return;

}


/*
* PLUS
*/

const plus =
event.target.closest(
'[data-qty-plus]'
);


if (plus) {

const card =
plus.closest(
'[data-card]'
);


const input =
card
? card.querySelector(
'.bb-qty-input'
)
: null;


if (input) {

input.value =
Math.min(
10,
Number(
input.value || 1
) + 1
);

}


return;

}


/*
* OPEN BUNDLE
*/

const bundleButton =
event.target.closest(
'[data-toggle-bundle]'
);


if (bundleButton) {

openDrawer();

return;

}


/*
* CLEAR
*/

const clear =
event.target.closest(
'[data-clear]'
);


if (clear) {

clearBundle();

return;

}

}
);


/*
* DRAWER EVENTS
*
* Drawer was moved to BODY,
* so events are handled on document.
*/

document.addEventListener(
'click',
function (event) {


/*
* REMOVE ITEM
*/

const remove =
event.target.closest(
'[data-remove-index]'
);


if (
remove &&
drawer &&
drawer.contains(remove)
) {

const index =
Number(
remove.dataset.removeIndex
);


bundle.splice(
index,
1
);


renderBundle();
updateDiscountUI();
updatePreview();


return;

}


/*
* CLOSE
*/

const close =
event.target.closest(
'[data-close-bundle]'
);


if (
close &&
drawer &&
drawer.contains(close)
) {

closeDrawer();

return;

}


/*
* BACK TO PRODUCTS
*/

const backProducts =
event.target.closest(
'[data-back-products]'
);


if (
backProducts &&
drawer &&
drawer.contains(backProducts)
) {

backToProducts();

return;

}


/*
* ADD BUNDLE TO CART
*/

const cart =
event.target.closest(
'[data-drawer-cart]'
);


if (
cart &&
drawer &&
drawer.contains(cart)
) {

addBundleToCart();

return;

}

}
);


/*
* VARIANT CHANGES
*/

builder.addEventListener(
'change',
function (event) {

const select =
event.target.closest(
'.bb-variant'
);


if (!select) {
return;
}


const card =
select.closest(
'[data-card]'
);


if (card) {

updateCardPrice(
card
);

}

}
);


/*
* DRAWER BACKDROP
*/

if (drawer) {

drawer.addEventListener(
'click',
function (event) {

if (
event.target === drawer
) {

closeDrawer();

}

}
);

}


/*
* ESCAPE
*/

document.addEventListener(
'keydown',
function (event) {

if (
event.key === 'Escape' &&
drawer &&
drawer.classList.contains(
'is-open'
)
) {

closeDrawer();

}

}
);


/*
* INITIALISE
*/

showStep(
1,
false
);


builder
.querySelectorAll(
'[data-card]'
)
.forEach(
function (card) {

updateCardPrice(
card
);

}
);


renderBundle();
updateDiscountUI();
updatePreview();

}


if (
document.readyState === 'loading'
) {

document.addEventListener(
'DOMContentLoaded',
initRoomBuilder
);

} else {

initRoomBuilder();

}

})();
